import { appointmentChannelId, form, isFlowForCalendar, providerId, providers, setProviderId, staffId } from '../../utils/variables';

export function selectProvider(id) {
    removeAllSelectProvider(id);
    let providerOption;
    if (id == -1) {
        providerOption = document.querySelector(
            `.provider__option[data-provider-id="-1"]`
        );
    }
    else {
        providerOption = document.querySelector(
            `.provider__option[data-provider-id="${CSS.escape(id)}"]`
        );
    }

    providerOption?.classList.add('is-selected');

    /* Unable Continue button */
    document
        .querySelector('.providerContinue__btn')
        ?.classList.remove('disabled');
}

export function removeAllSelectProvider(id = null) {
    setProviderId('');

    if (providers.length === 1) {
        const id = providers[0].id;
        setProviderId(id);
    }

    if (id && appointmentChannelId) {
        setProviderId(id);
    }

    document
        .querySelectorAll('.provider__option')
        .forEach((i) => i.classList.remove('is-selected'));

    document.querySelector('.providerContinue__btn')?.classList.add('disabled');
}

export function removeHiddenClassInProvider() {
    document.querySelectorAll('.providers__container .provider').forEach((i) => {
        i.classList.remove('hidden');
    });
}

export function getProviderFullName() {
    if (!isFlowForCalendar || form?.appointment_channel?.host === 'one_on_one') {
        const currentProviderId = providerId || staffId;
        const selectedProvider = providers.find(provider => provider.id === currentProviderId);
        return `${selectedProvider?.first_name ?? ""} ${selectedProvider?.last_name ?? ""}`.trim() || 'No preference';
    }

    const hostMessages = {
        round_robin: 'No preference',
        collective: 'Team members'
    };

    return hostMessages[form?.appointment_channel?.host] ?? 'No preference';
}

export function renderContinueBtn() {
    document.querySelector('.providerContinue__btn-wrapper').innerHTML = '';
    document.querySelector('.providerContinue__btn-wrapper').insertAdjacentHTML('beforeend',
        '<div class="providerContinue__btn disabled">Continue <span class="loader__icon"> <i class="ri-arrow-right-line"></i></span><div class="loading__wrapper hidden"><div class="loader"></div></div></div>');
}